import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { client } from "../../../configs/client";

export const activityLogs = createAsyncThunk(
  "activity/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await client.post(`activity-logs/add`, payload);

      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const activityLogSlice = createSlice({
  name: "acttivity_logs",
  initialState: {
    isLoading: false,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(activityLogs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(activityLogs.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(activityLogs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default activityLogSlice.reducer;
